import styled from 'styled-components'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { SMALL_MOBILE_HEIGHT } from 'containers/SubSidebar/TtsContent/consts'

export const TtsItemSpeakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (max-height: ${SMALL_MOBILE_HEIGHT}px) {
    overflow: hidden scroll;
    ${customizeVerticalScrollbarThumbMixin()}
  }
`

export const TtsItemSpeakerContentRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
